import React, {useEffect, useState} from 'react';
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import s from "../../../styles/styles.module.css";
import {motion} from "framer-motion";
import BankTransfer from "./BankTransfer/BankTransfer";
import ToAnLuxPay from "./ToAnLuxPay/ToAnLuxPay";
import VerifyWithdrawalHelper from "../../../helpers/VerifyWithdrawalHelper";
import {useAppSelector} from "../../../hooks/redux";
import styles from "../../../styles/styles.module.css";
import MyBtn from "../../../components/ui/MyBtn/MyBtn";
import CustomModal from "../../../components/ui/CustomModal/CustomModal";
import {useNavigate} from "react-router-dom";

const Transfers = () => {

    const presavedTabIndex: number = useAppSelector(state => state.transactionsReducer.transferDataPreview.tabIndex)

    const [tabIndex, setTabIndex] = useState(presavedTabIndex || 0);
    const [isButtonDisable, setIsButtonDisabled] = useState(true)
    const [withdrawalStatus, setWithdrawalStatus] = useState("")
    const is2FaEnabled = useAppSelector(state => state.userReducer.user.verificationsList.twoFaVerifyEnabled)
    const userAccountStatus = useAppSelector(state => state.userReducer.user.userData.userAccountStatusLabel)
    const navigate = useNavigate()

    if (!is2FaEnabled) {
        return (
            <div>
                <CustomModal type={"error"} isNotify isModalOpen={!is2FaEnabled}>
                    <div className={styles.modal_content}>
                        <div className={styles.popup_subtitle}>
                            <span className={styles.error}>Failed!</span> You can not perform transactions until you set up Google Authenticator (2FA)
                        </div>
                        <div className={styles.popup_button_block}>
                            <MyBtn buttonType={"error"} isPersonalAccountBtn title={"Ok"}
                                   onClick={() => navigate('/personal-account/security')}/>
                        </div>
                    </div>
                </CustomModal>
            </div>
        )
    }

    if (userAccountStatus === 'Suspended') {
        return (
            <div>
                <CustomModal type={"error"} isNotify isModalOpen={true}>
                    <div className={styles.modal_content}>
                        <div className={styles.popup_subtitle}>
                            <span className={styles.error}>Failed!</span> You’re temporarily unable to make transfers
                            because your account has been suspended. Please try again later or contact support.
                        </div>
                        <div className={styles.popup_button_block}>
                            <MyBtn buttonType={"error"} isPersonalAccountBtn title={"Ok"}
                                   onClick={() => navigate('/personal-account/accounts')}/>
                        </div>
                    </div>
                </CustomModal>
            </div>
        )
    }

    if (withdrawalStatus === 'notVerified' || withdrawalStatus === 'blocked' || withdrawalStatus === '') {
        return (
            <VerifyWithdrawalHelper
                setWithdrawalStatus={setWithdrawalStatus}
                setIsButtonDisabled={setIsButtonDisabled}
            />
        )
    }

    if (withdrawalStatus === 'allowed') {
        return (
            <motion.div
                initial={{opacity: 0, scale: 1}}
                animate={{opacity: 1, scale: 1}}
                transition={{duration: 0.5}}
            >
                <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                    <TabList className={s.tabstitle_block}>
                        <Tab selectedClassName={s.active_tab} className={s.tabtitle}>Bank Transfer</Tab>
                        <Tab selectedClassName={s.active_tab} className={s.tabtitle}>To a LuxPay User</Tab>
                    </TabList>

                    <TabPanel>
                        <BankTransfer
                            isButtonDisable={isButtonDisable}
                        />
                    </TabPanel>
                    <TabPanel>
                        <ToAnLuxPay
                            isButtonDisable={isButtonDisable}
                            setIsButtonDisabled={setIsButtonDisabled}
                            tabIndex={tabIndex}
                        />
                    </TabPanel>
                </Tabs>
            </motion.div>
        );
    }

    return null
};

export default Transfers;
